(() => {
  const postcodes = [
    '2474', '2476', '2484', '2485', '2486', '2487', '2488', '2489', '2490',
    '4000', '4005', '4006', '4007', '4008', '4009', '4010', '4011', '4012',
    '4013', '4014', '4017', '4018', '4019', '4020', '4021', '4022', '4025',
    '4030', '4031', '4032', '4034', '4035', '4036', '4037', '4051', '4053',
    '4054', '4055', '4059', '4060', '4061', '4064', '4065', '4066', '4067',
    '4068', '4069', '4070', '4073', '4074', '4075', '4076', '4077', '4078',
    '4101', '4102', '4103', '4104', '4105', '4106', '4107', '4108', '4109',
    '4110', '4111', '4112', '4113', '4114', '4115', '4116', '4117', '4118',
    '4119', '4120', '4121', '4122', '4123', '4124', '4125', '4127', '4128',
    '4129', '4130', '4131', '4132', '4133', '4151', '4152', '4153', '4154',
    '4155', '4156', '4157', '4158', '4159', '4160', '4161', '4163', '4164',
    '4165', '4169', '4170', '4171', '4172', '4173', '4174', '4178', '4179',
    '4183', '4184', '4205', '4207', '4208', '4209', '4210', '4211', '4212',
    '4213', '4214', '4215', '4216', '4217', '4218', '4219', '4220', '4221',
    '4222', '4223', '4224', '4225', '4226', '4227', '4228', '4230', '4270',
    '4271', '4272', '4275', '4280', '4285', '4287', '4300', '4301', '4303',
    '4304', '4305', '4306', '4307', '4309', '4310', '4311', '4312', '4313',
    '4314', '4340', '4341', '4342', '4343', '4344', '4345', '4346', '4347',
    '4350', '4352', '4353', '4354', '4355', '4358', '4359', '4360', '4361',
    '4362', '4370', '4371', '4373', '4400', '4500', '4501', '4502', '4503',
    '4504', '4505', '4506', '4507', '4508', '4509', '4510', '4511', '4512',
    '4514', '4515', '4516', '4517', '4518', '4519', '4520', '4521', '4550',
    '4551', '4552', '4553', '4554', '4555', '4556', '4557', '4558', '4559',
    '4560', '4561', '4562', '4563', '4564', '4566', '4567', '4572', '4573',
    '4574', '4575', '9464', '9726', '4580', '4655', '4570', '4670', '4650',
    '4660', '4625', '4680'
  ];

  window.GoTurfServicePostcodes = postcodes;

  try {
    if (typeof map_data !== 'undefined' && map_data) {
      map_data.list_postcodes = postcodes;
    }
  } catch (error) {
    // The cart page does not create map_data.
  }
})();
